import { FormControl, FormLabel, InputLabel, MenuItem, Select } from "@mui/material";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { getPsychologists, Psychologist } from "src/apis/psychologist";
import { Id } from "src/utils/types";

type PsychologistSelectProps = {
  isFilter?: boolean,
  psychologistId: Id,
  setPsychologistId: (id: Id) => void,
  setError: (err: string) => void,
}

const PsychologistSelect: FC<PsychologistSelectProps> = ({
  isFilter = false,
  psychologistId,
  setPsychologistId,
  setError,
}): JSX.Element => {
  const [psychologists, setPsychologists] = useState<Psychologist[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const props = useMemo<object>(() => {
    if (!isFilter) return {};

    return {
      label: "Empresa"
    }
  }, [isFilter])

  const fetchPsychologists = useCallback(async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await getPsychologists();

      setPsychologists(response);
      setError('');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, [isLoading, setError]);

  useEffect(() => {
    fetchPsychologists();
  }, [fetchPsychologists])

  return (
    <FormControl>
      {isFilter ? (
        <InputLabel id="label-select">Psicólogo</InputLabel>
      ) : (
        <FormLabel id="label-select">Psicólogo</FormLabel>
      )}

      <Select
        labelId="label-select"
        variant="outlined"
        value={psychologistId ?? ''}
        onChange={(e) => {
          setPsychologistId(e.target.value as string);
        }}
        sx={{
          width: isFilter ? '200px' : '100%'
        }}
        {...props}
      >
        {psychologists?.map((p) => (
          <MenuItem key={p.id} value={String(p.id)}>
            {p.name} - {p.email}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default PsychologistSelect;
